import { useEffect, useState } from "react";
import { dbFetchLeaderboard } from "../db";

export default function LeaderboardScreen({ onBack, onViewProfile }) {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    dbFetchLeaderboard().then(setRows);
  }, []);

  const medal = (i) => i === 0 ? "🥇" : i === 1 ? "🥈" : i === 2 ? "🥉" : `${i + 1}.`;

  return (
    <div style={{ background: "#0a0f16", minHeight: "100vh", fontFamily: "Georgia, serif", color: "#e8dcc8" }}>
      <div style={{ padding: "14px 20px", borderBottom: "1px solid #1a2530", display: "flex", alignItems: "center", gap: 16 }}>
        <span onClick={onBack} style={{ color: "#c9a84c", fontSize: 11, letterSpacing: 2, cursor: "pointer", opacity: 0.7 }}>← BACK</span>
        <span style={{ color: "#c9a84c", fontSize: 13, letterSpacing: 4 }}>LEADERBOARD</span>
      </div>

      <div style={{ maxWidth: 580, margin: "0 auto", padding: "20px 16px" }}>
        <div style={{ display: "grid", gridTemplateColumns: "40px 1fr 80px 80px 80px", gap: 0,
          fontSize: 9, color: "#4a5a6a", letterSpacing: 2, padding: "0 14px 10px", textTransform: "uppercase" }}>
          <span>#</span><span>Player</span><span style={{ textAlign: "right" }}>Best</span>
          <span style={{ textAlign: "right" }}>Avg</span><span style={{ textAlign: "right" }}>Games</span>
        </div>

        {rows === null && (
          <div style={{ textAlign: "center", color: "#4a5a6a", letterSpacing: 3, fontSize: 11, marginTop: 40 }}>LOADING...</div>
        )}

        {rows?.map((r, i) => (
          <div key={r.user_id}
            onClick={() => onViewProfile?.(r.user_id, r.display_name)}
            style={{
              display: "grid", gridTemplateColumns: "40px 1fr 80px 80px 80px",
              alignItems: "center", padding: "12px 14px", marginBottom: 4,
              background: i < 3 ? "rgba(201,168,76,0.05)" : "#0d1520",
              border: `1px solid ${i < 3 ? "rgba(201,168,76,0.15)" : "#1e2e3e"}`,
              borderRadius: 6, fontSize: 12,
              cursor: onViewProfile ? "pointer" : "default",
            }}>
            <span style={{ color: "#c9a84c", fontSize: i < 3 ? 16 : 11 }}>{medal(i)}</span>
            <span style={{ color: "#e8dcc8", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {r.display_name || "Anonymous"}
            </span>
            <span style={{ textAlign: "right", color: "#6fcf97", fontWeight: "bold" }}>{r.best_score}</span>
            <span style={{ textAlign: "right", color: "#9aa6b8" }}>{r.avg_score}</span>
            <span style={{ textAlign: "right", color: "#4a5a6a" }}>{r.games_played}</span>
          </div>
        ))}

        {rows?.length === 0 && (
          <div style={{ textAlign: "center", color: "#4a5a6a", letterSpacing: 2, fontSize: 11, marginTop: 40 }}>
            No scores yet. Be the first!
          </div>
        )}
      </div>
    </div>
  );
}
